import SharedAudioContext from '../../stores/SharedAudioContext'

export default class SoundPlayer {
  private audioCtx = SharedAudioContext
  private source
  soundDuration = -1

  /**
   * Plays the given decodedAudioData with WebAudioAPI. Useful for previewing samples.
   *
   * @param decodedAudioData The audio data to play.
   * @param onPlayStateChangedCallback Called with "true" when the sample starts playing, and "false" when it stops.
   * @param note pitch to play the note at, in the global coordinate system. Defaults to "Middle C".
   */
  play(
    decodedAudioData: AudioBuffer,
    onPlayStateChangedCallback: (boolean) => void,
    semitoneOffset = 0,
    gain: number = 1
  ) {
    if (!decodedAudioData) return
    if (this.source) this.source.stop(0)
    this.source = this.audioCtx.createBufferSource()
    this.source.buffer = decodedAudioData

    var gainNode = this.audioCtx.createGain()
    gainNode.gain.value = gain
    gainNode.connect(this.audioCtx.destination)
    this.source.connect(gainNode)

    if (semitoneOffset !== 0 && this.source.playbackRate) {
      this.source.playbackRate.value = Math.pow(2, semitoneOffset / 12)
    }

    onPlayStateChangedCallback(true)
    this.soundDuration = decodedAudioData.duration

    this.source.addEventListener('ended', () => {
      onPlayStateChangedCallback(false)
    })

    this.source.start(0)
  }

  stop() {
    if (this.source) this.source.stop(0)
    this.soundDuration = -1
    this.source = null
  }
}
